import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-6 md:px-10 max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-12">
          {t('section_all_categories_title')}
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="relative aspect-square rounded-xl overflow-hidden group cursor-pointer"
            >
              <img
                src={cat.gridImageUrl}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-3">
                <h3 className="text-white text-base md:text-lg font-heading font-semibold">{cat.name}</h3>
                <p className="text-white/65 text-xs mt-1 hidden sm:block">{cat.desc}</p>
              </div>
              <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-black/30 to-transparent"></div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}